import { useState } from "react";
import useChidDetails from "./useChildDetails";
import { KidTile } from "../../components/Kids/kidTile";
import useUserDetailsStore from "../../store/UserStore";
import { useNavigate } from "react-router-dom";
import StoryEmptyImg from "../../assets/storyEmpty.svg";
import toast from "react-hot-toast";
import { CircularProgress } from "@mui/material";
import { DialogWrapper } from "../../components/Dialog";
import { SubTitle } from "../../components/molecules/subtitle";
import { TransparentButton } from "../../components/Button/TransparentButton";
import { Title } from "../../components/molecules/header";
import { Helmet } from "react-helmet-async";

export const Kids = () => {
  const {
    kidsData,
    deleteKid,
    loading: childDetailsLoading,
  } = useChidDetails();
  const navigate = useNavigate();
  const [deleteChildId, setdeleteChildId] = useState(null);
  const [canAddHuman] = useUserDetailsStore((state) => [state.canAddHuman]);
  const openDeleteDialog = (id) => {
    setdeleteChildId(id);
  };
  const closeDeleteKidDialog = () => {
    setdeleteChildId(null);
  };
  const FullPageLoading = () => {
    return (
      <div className="relative w-[100%] h-[80vh]">
        <div className="z-50 flex justify-center items-center absolute top-0 left-0 w-[100%] h-[100%] opacity-80 ">
          <CircularProgress sx={{ color: "#3CC3AA" }} />
        </div>
      </div>
    );
  };
  if (childDetailsLoading && kidsData.length === 0) {
    return <FullPageLoading />;
  }
  if (kidsData.length === 0 || !kidsData) {
    return (
      <div className="flex flex-col items-center justify-center">
        <img src={StoryEmptyImg} alt="empty story" />
        <p className="text-md my-4">
          You have no child added. Let’s get started by adding a child!
        </p>
        <TransparentButton
          className="px-10 py-2 rounded-full text-[#3CC3AA] font-bold text-lg border-2 border-solid border-[#3CC3AA]"
          onClick={() => {
            if (canAddHuman) {
              navigate("/add-human");
            } else {
              toast(
                "You have hit the plan limit. See subscription details for more info"
              );
            }
          }}
        >
          + Add Human
        </TransparentButton>
      </div>
    );
  }

  return (
    <div>
      <Helmet title="StoryGenius - Humans"></Helmet>
      <div className="items-center justify-center gap-4 p-6 sm:p-8">
        <div className="w-auto ">
          <div className=" flex justify-end lg:float-right mb-4 lg:m-0 lg:mt-2  ">
            <TransparentButton
              style={{ margin: 0 }}
              onClick={() => {
                if (canAddHuman) {
                  navigate("/add-human");
                } else {
                  toast(
                    "You have hit the plan limit. See subscription details for more info"
                  );
                }
              }}
            >
              + Add Human
            </TransparentButton>
          </div>
          <div className="w-fit  m-auto items-center relative">
            <Title>Humans</Title>
          </div>
        </div>
      </div>

      <div className="container m-auto p-2 md:p-8 ">
        <div className="flex items-center relative justify-center ">
          <DialogWrapper isOpen={deleteChildId} onClose={closeDeleteKidDialog}>
            <div className="flex flex-col items-center justify-center p-4">
              <SubTitle>
                Are you sure you want to delete <br />
                <strong>
                  {kidsData.find((kid) => kid.id === deleteChildId)?.name || ""}{" "}
                </strong>{" "}
                from your child list?
              </SubTitle>
              <div className="flex justify-center gap-4 my-4">
                <TransparentButton
                  className={
                    "hover:bg-red-500 border border-red-500 text-red-500"
                  }
                  handleButtonClick={() => {
                    deleteKid(deleteChildId);
                    closeDeleteKidDialog();
                  }}
                >
                  Delete
                </TransparentButton>
                <TransparentButton
                  className={
                    "hover:bg-slate-300 border border-slate-200 text-slate-500"
                  }
                  handleButtonClick={() => {
                    closeDeleteKidDialog();
                  }}
                >
                  Cancel
                </TransparentButton>
              </div>
            </div>
          </DialogWrapper>

          <div className="flex  gap-x-6 gap-y-4 justify-center items-center cursor-pointer w-full flex-wrap">
            {kidsData?.map((kid) => (
              <KidTile key={kid.id} kid={kid} deleteKid={openDeleteDialog} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
